import React, { Component } from 'react'

import Countries from 'i18n-iso-countries'
import { Button } from '@/components/ui/button'
import { MapPin, Globe, Lock } from 'react-feather'
import ReactCountryFlag from 'react-country-flag'
import ip from 'ip'
import axios from 'axios'
import _padStart from 'lodash/padStart'

import Tool from '../utils/Tool'
import ResizablePanels from '../utils/ResizablePanels'
import FormInput from '../utils/FormInput'
import Tools from '../utils/Tools'
import logger from '../utils/Logger'

import '../App.css'

const IpToCountry = {}
import('../resources/IpToCountry0000.json').then(obj => { IpToCountry['0000'] = obj.list })
import('../resources/IpToCountry0001.json').then(obj => { IpToCountry['0001'] = obj.list })
import('../resources/IpToCountry0010.json').then(obj => { IpToCountry['0010'] = obj.list })
import('../resources/IpToCountry0011.json').then(obj => { IpToCountry['0011'] = obj.list })
import('../resources/IpToCountry0100.json').then(obj => { IpToCountry['0100'] = obj.list })
import('../resources/IpToCountry0101.json').then(obj => { IpToCountry['0101'] = obj.list })
import('../resources/IpToCountry0110.json').then(obj => { IpToCountry['0110'] = obj.list })
import('../resources/IpToCountry0111.json').then(obj => { IpToCountry['0111'] = obj.list })
import('../resources/IpToCountry1000.json').then(obj => { IpToCountry['1000'] = obj.list })
import('../resources/IpToCountry1001.json').then(obj => { IpToCountry['1001'] = obj.list })
import('../resources/IpToCountry1010.json').then(obj => { IpToCountry['1010'] = obj.list })
import('../resources/IpToCountry1011.json').then(obj => { IpToCountry['1011'] = obj.list })
import('../resources/IpToCountry1100.json').then(obj => { IpToCountry['1100'] = obj.list })
import('../resources/IpToCountry1101.json').then(obj => { IpToCountry['1101'] = obj.list })
import('../resources/IpToCountry1110.json').then(obj => { IpToCountry['1110'] = obj.list })
import('../resources/IpToCountry1111.json').then(obj => { IpToCountry['1111'] = obj.list })

class IpAddress extends Component {
    constructor(props) {
        super(props)

        this.state = {
            dotted: '',
            integer: '',
            country: null,
            checkIp: false,
            invalidDotted: null,
            invalidInteger: null,
        }

        this.onDottedChange = this.onDottedChange.bind(this)
        this.onIntegerChange = this.onIntegerChange.bind(this)
        this.onRetrieveCurrentPublicAddress = this.onRetrieveCurrentPublicAddress.bind(this)

        this.getIpToCountry = this.getIpToCountry.bind(this)
        this.getPublicIp = this.getPublicIp.bind(this)
        this.binarySearch = this.binarySearch.bind(this)

        this.breadcrumbs = [
            {
                title: IpAddress.getTitle(),
                active: true,
            }
        ]
        this.glossary = [
            {
                title: "Internet Protocol",
                pageId: "Internet_Protocol"
            },
            {
                title: "IP address",
                pageId: "IP_address"
            },
            {
                title: "Dot-decimal notation",
                pageId: "Dot-decimal_notation"
            }
        ]
    }

    static RETRIEVE_PUBLIC_IP_BUTTON = "Retrieve current public address"

    static getTitle() {
        return Tools.Names.IpAddress
    }
    static getSearchTitle() {
        return IpAddress.getTitle()
    }
    static getTags() {
        return [
            "network",
            "ipv4",
            "ipv6",
            "public",
            "geoip",
            "country",
            "flag",
        ]
    }

    onDottedChange(event) {
        const addr = event.target.value
        if (ip.isV4Format(addr)) {
            try {
                const ipDec = ip.toLong(addr)
                this.setState(Object.assign({}, this.state, {
                    dotted: addr,
                    integer: ipDec,
                    country: this.getIpToCountry(ipDec),
                    invalidDotted: null,
                }))
            }
            catch(e) {
                this.setState(Object.assign({}, this.state, {
                    dotted: addr,
                    integer: '',
                    country: null,
                    invalidDotted: e.toString(),
                }))
            }
        }
        else {
            this.setState(Object.assign({}, this.state, {
                dotted: addr,
                integer: '',
                country: null,
                invalidDotted: 'Only IPv4 addresses are supported at the moment.',
            }))
        }
    }
    onIntegerChange(event) {
        const addrStr = event.target.value
        try {
            const addr = parseInt(addrStr, 10)
            this.setState(Object.assign({}, this.state, {
                dotted: ip.fromLong(addr),
                integer: addrStr,
                country: this.getIpToCountry(addr),
                invalidInteger: null,
            }))
        }
        catch(e) {
            this.setState(Object.assign({}, this.state, {
                dotted: '',
                integer: addrStr,
                country: null,
                invalidInteger: e.toString(),
            }))
        }
    }

    onRetrieveCurrentPublicAddress() {
        const self = this
        self.setState(Object.assign({}, self.state, {
            checkIp: true,
        }))
        self.getPublicIp((err, data) => {
            if (data) {
                const ipDec = parseInt(data, 10)
                self.setState(Object.assign({}, self.state, {
                    dotted: ip.fromLong(ipDec),
                    integer: data,
                    country: self.getIpToCountry(ipDec),
                    checkIp: false,
                }))
            }
            else {
                self.setState(Object.assign({}, self.state, {
                    country: null,
                    checkIp: false,
                }))
            }
        })
    }

    getPublicIp(callback) {
        axios
        .get('/server/publicip.js')
        .then(function (response) {
            logger.debug(response)
            callback(null, response.data)
        })
        .catch(function (error) {
            logger.warn(error)
            callback(error)
        })
    }

    getIpToCountry(ipDec) {
        const bin = _padStart(ipDec.toString(2), 32, '0').substr(0, 4) // FIXME numBits
        const list = IpToCountry[bin]
        //const list = import('../resources/IpToCountry'+bin+'.json')
        const result = this.binarySearch(list, ipDec, 0, list.length-1)
        if (result) {
            return result[2]
        }
        return null
    }
    binarySearch(list, ipInt, start, end) {
        if (start > end) return false

        const midIdx = Math.floor((start + end)/2)
        const mid = list[midIdx]

        if (ipInt < mid[0]) {
            // If element at mid is greater than x,
            // search in the left half of mid
            return this.binarySearch(list, ipInt, start, midIdx-1)
        }
        else if (mid[1] < ipInt) {
            // If element at mid is smaller than x,
            // search in the right half of mid
            return this.binarySearch(list, ipInt, midIdx+1, end)
        }
        else if (mid[0] <= ipInt && ipInt <= mid[1]) {
            return mid  // found it!
        }
        return false  // not found
    }

    render() {
        const code = (!!this.state.country && this.state.country.length === 2) ? this.state.country : false

        let flag = '-'
        let priv
        if (this.state.dotted && ip.isV4Format(this.state.dotted) && ip.isPrivate(this.state.dotted)) {
            priv = <span><Lock className={ "icon-xs" } /> Private</span>
        }
        else {
            priv = <span><Globe className={ "icon-xs" } /> Public</span>
            if (code) {
                flag = <ReactCountryFlag code={ code } />
            }
        }

        const spinCls = this.state.checkIp ? " icon-spin" : ""

        return (
            <Tool
                breadcrumbs={ this.breadcrumbs }
                title={ IpAddress.getSearchTitle() }
                glossary={ this.glossary }>
            <ResizablePanels storageKey="ip-address">
                <div>
                    <div className="mb-3 form-padding">
                        <label className="text-sm font-medium mb-1 block">Dotted</label>
                        <FormInput
                            type="text"
                            value={ this.state.dotted }
                            onChange={ this.onDottedChange }
                            invalidMessage={ this.state.invalidDotted }
                            focusOnMount={ true } />
                        <p className="text-sm text-muted-foreground">
                            IPv4 address in dotted notation.
                        </p>
                    </div>
                </div>
                <div>
                    <div className="mb-3 form-padding">
                        <label className="text-sm font-medium mb-1 block">Integer</label>
                        <FormInput
                            type="text"
                            value={ this.state.integer }
                            onChange={ this.onIntegerChange }
                            invalidMessage={ this.state.invalidInteger } />
                        <p className="text-sm text-muted-foreground">
                            IPv4 address in integer.
                        </p>
                    </div>
                </div>
            </ResizablePanels>
            <div className="form-padding">
                <div className="mb-3">
                    <table className="w-full text-sm border-collapse">
                        <thead>
                            <tr>
                                <th className="border px-3 py-2 text-left font-medium bg-muted">Flag</th>
                                <th className="border px-3 py-2 text-left font-medium bg-muted">Name</th>
                                <th className="border px-3 py-2 text-left font-medium bg-muted">ISO 3166-1 alpha-2</th>
                                <th className="border px-3 py-2 text-left font-medium bg-muted">ISO 3166-1 alpha-3</th>
                                <th className="border px-3 py-2 text-left font-medium bg-muted">Private?</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td className="border px-3 py-2">{ flag }</td>
                                <td className="border px-3 py-2">{ !!code ? Countries.getName(code, 'en') : '-' }</td>
                                <td className="border px-3 py-2">{ !!code ? code : '-' }</td>
                                <td className="border px-3 py-2">{ !!code ? Countries.alpha2ToAlpha3(code) : '-' }</td>
                                <td className="border px-3 py-2">{ priv }</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div className="mb-3">
                    <Button variant="outline" onClick={ this.onRetrieveCurrentPublicAddress } disabled={ this.state.checkIp }>
                        <MapPin className={ "icon-xxs"+spinCls } />{ IpAddress.RETRIEVE_PUBLIC_IP_BUTTON }
                    </Button>
                </div>
            </div>
            </Tool>
        )
    }
}

export default IpAddress

/*
            <form className={ "form-padding" }>
            </form>
*/
